import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

import type { QueryKey } from '@tanstack/react-query';

const strainsQueryKey: QueryKey = ['strains'];

const GET_STRAINS = 'api/strain/get-strains';

type StrainResponse = {
  Abbreviation: string | null;
  ExternalId: string | null;
  StrainAbbreviation: string | null;
  StrainDescription: string | null;
  StrainId: number;
  StrainName: string | null;
  StrainType: string | null;
};

export function useStrainsQuery<T = StrainResponse[]>(params?: {
  enabled?: boolean;
  select?: (data: StrainResponse[]) => T;
  staleTime?: number;
}) {
  const { enabled, staleTime, select } = params ?? {};

  return useQuery({
    queryKey: strainsQueryKey,
    queryFn: () => fetchData<StrainResponse[]>(GET_STRAINS),
    enabled,
    staleTime,
    select,
  });
}
